import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Quemsomos from '../Quemsomos';
import { Container, Row, Col, Carousel, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import Contacto from '../Contacto';
import Clientes from '../Clientes';
import QuoteButton from '../QuoteButton';

import um from '../../img/Manutencao/4.jpg';
import dois from '../../img/Manutencao/2.png';
import tres from '../../img/Manutencao/7.jpg';
import quatro from '../../img/Manutencao/6.png';
import cinco from '../../img/Manutencao/2.png';
import seis from '../../img/Manutencao/4.jpg';
import sete from '../../img/Manutencao/6.png';
import oito from '../../img/Manutencao/7.jpg';
import consultoria from '../../img/consultoria.png';
import predial from '../../img/predial.png';
import ti from '../../img/ti.png';

import './Home.css';

const Home = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    setFormData({
      name: '',
      email: '',
      message: '',
    });
  };

  return (
    <div style={{ fontFamily: 'Montserrat, sans-serif' }}>
      {/* Helmet: SEO e metatags */}
      <Helmet>
  <html lang="pt-BR" />
  <title>Início | Soluções em Manutenção e Tecnologias de informação</title>
  <meta name="description" content="Especialistas em manutenção predial, Tecnologias de informação e consultoria empresarial. Soluções personalizadas para sua empresa." />
  <meta name="keywords" content="manutenção, tecnologia da informação, consultoria, prédios, suporte técnico" />
  <meta property="og:title" content="Início | Soluções em Manutenção e Tecnologias de informação" />
  <meta property="og:description" content="Serviços integrados para empresas que precisam de manutenção predial e tecnologia confiável." />
  <meta property="og:image" content="https://nwayami.com/img/destaque.jpg" />
  <meta name="robots" content="index, follow" />
</Helmet>


      {/* Carrossel de Imagens */}
      <section className="section1" style={{ marginTop: '100px', marginBottom: '120px' }}>
        <Carousel className="carousel1">
          <Carousel.Item className="carousel-item1" style={{ height: 'calc(85vh - 6.25rem)' }} />
          <Carousel.Item className="carousel-item2" style={{ height: 'calc(85vh - 6.25rem)' }} />
          <Carousel.Item className="carousel-item3" style={{ height: 'calc(85vh - 6.25rem)' }} />
        </Carousel>

        <div style={{ height: '6.25rem', backgroundColor: '#ff5722', position: 'relative' }}>
          <div
            style={{
              width: '16.25rem',
              height: '6.25rem',
              backgroundColor: 'white',
              position: 'absolute',
            }}
          ></div>
        </div>

        <div id="quem-somos"></div>
      </section>

      <QuoteButton />
      <Quemsomos />

      {/* Serviços */}
      <section style={{ marginBottom: '190px' }}>
        <Container>
          <h2 className="text-center" style={{ fontSize: '46px', position: 'relative' }}>
            <b>Serviços</b>
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '50%',
                height: '2px',
                backgroundColor: '#ff5722',
              }}
            ></div>
          </h2>
          <Row className="d-flex justify-content-between">
            {/* Manutenção Predial */}
            <Col
              md={3}
              style={{
                backgroundColor: '#ffe7e0',
                minHeight: '400px',
                padding: '20px',
                transition: 'transform 0.3s ease-in-out',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
              <div className="text-center">
                <img src={predial} alt="Manutenção Predial" className="img-fluid" style={{ height: '100px' }} />
                <h5 style={{ color: '#ff5722', fontSize: '18px' }}>Manutenção Predial</h5>
              </div>
              <p>Oferecemos serviços especializados de manutenção predial Garantindo a conservação e o bom funcionamento de todos os sistemas e estruturas do seu imovel</p>
              <Link to="/Manutencaopredial">
                <Button style={{ backgroundColor: '#FF5722', borderColor: '#FF5722' }}>Saiba mais</Button>
              </Link>
            </Col>

            {/* Tecnologia da Informação */}
            <Col
              md={3}
              style={{
                backgroundColor: '#ffe7e0',
                minHeight: '400px',
                padding: '20px',
                transition: 'transform 0.3s ease-in-out',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
              <div className="text-center">
                <img src={ti} alt="Tecnologia da Informação" className="img-fluid" style={{ height: '100px' }} />
                <h5 style={{ color: '#ff5722', fontSize: '18px' }}>Tecnologia de Informação</h5>
              </div>
              <p>Oferecemos otimização a infraestrutura digitasl da sua empresa. Melhorando a conectividade e a seguarança dos seus sistema. Actuamos em diversas areas como implementação e manutenção de redes, suporte tecnico garantindo o melhor deempenho e a protecção dos seus dados </p>
              <Link to="/TecnologiaDeinformação">
                <Button style={{ backgroundColor: '#FF5722', borderColor: '#FF5722' }}>Saiba mais</Button>
              </Link>
            </Col>

            {/* Consultoria */}
            <Col
              md={3}
              style={{
                backgroundColor: '#ffe7e0',
                minHeight: '400px',
                padding: '20px',
                transition: 'transform 0.3s ease-in-out',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
              <div className="text-center">
                <img src={consultoria} alt="Consultoria" className="img-fluid" style={{ height: '100px' }} />
                <h5 style={{ color: '#ff5722', fontSize: '18px' }}>Consultoria</h5>
              </div>
              <p>Oferecemos soluções personalizadas para a gestão eficaz da Manutenção predial e da tecnologia de informação. Ajudamos sua empresa a identificar necessidades especificas, implementar melhorias e otimizar processos com foco em eficiencia, segurança e redução de custos operacionais</p>
              <Link to="/">
                <Button style={{ backgroundColor: '#FF5722', borderColor: '#FF5722' }}>Saiba mais</Button>
              </Link>
            </Col>
          </Row>
        </Container>
        <div id="projectos"></div>
      </section>

      {/* Projetos */}
      <section style={{ marginBottom: '190px' }}>
        <Container>
          <h2 className="text-center" style={{ fontSize: '46px', position: 'relative' }}>
            <b>Projectos</b>
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '50%',
                height: '2px',
                backgroundColor: '#ff5722',
                
              }}
            ></div>
          </h2>

          <Carousel interval={null}>
            {[ [um, dois, tres], [quatro, cinco, seis], [sete, oito, um] ].map((grupo, idx) => (
              <Carousel.Item key={idx} style={{ height: '40vh' }}>
                <div className="d-flex justify-content-between">
                  {grupo.map((img, i) => (
                    <div className="card" key={i} style={{ flex: 1, margin: '10px', border: 'none' }}>
                      <img src={img} alt={`Imagem ${i + 1}`} className="card-img-top" style={{ objectFit: 'cover',height: '190px',width: '80%',borderRadius: '8px',  }} />
                    </div>
                  ))}
                </div>
              </Carousel.Item>
            ))}
          </Carousel>

          <div className="text-center" style={{ fontSize: '30px' }}>
            Unimos expertise em: <span style={{ color: '#ff5722' }}>Manutenção Predial</span> e{' '}
            <span style={{ color: '#ff5722' }}>Tecnologia de Informação</span>
          </div>
        </Container>
      </section>

      {/* Clientes */}
      <Clientes />

      {/* Contato */}
      <Contacto />
    </div>
  );
};

export default Home;
